<template>
    <div class="row m-0">
        <div class="col-12">
            <div class="row headers text-dark text-center py-3">
            <h2 class="h4 m-0 mx-auto"> {{ $t("achievement") }} </h2>
            </div>
            <div class="row">
                <div class="sections p-3">
                    <div class="card w-100 border-0">
                        <div class="card-title mb-0">
                            <div class="float-left">
                                <div class="media mt-2">
                                    <img src="@/assets/images/starcoach.png" class="place-logos rounded" alt="starcoach">
                                    <div class="media-body ml-2">
                                        <span class="d-block"> {{ $t("starcoach_rank") }} - <small> 74 {{ $t("team") }} </small> </span>
                                        <span class="d-block"> Starcoach Agentic AI Hackathon </span>
                                        <span class="d-block small"> {{ $t("starcoach_sub") }} </span>
                                        <span class="d-block"> <small> <a
                                                href="https://starcoach.ir/hackathon/agentic-ai"
                                                target="_blank"> {{ $t("starcoach_site") }} </a> </small> </span>
                                    </div>
                                </div>
                            </div>
                            <div class="float-right mt-2">
                                <small> {{ $t("starcoach_time") }} </small>
                                <vs-button class="m-0 mt-1 ml-auto custom-icon-size"
                                           href="/images/starcoach-certificate.jpg"
                                           size="mini" transparent active blank color="#22333B">
                                    <i class='bx bx-certification mr-1'></i>
                                    <span class="small-padding-top"> {{ $t("certificate") }} </span>
                                </vs-button>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div class="card w-100 border-0 mt-4">
                        <div class="card-body p-0">
                            <div class="card-title mb-0">
                                <div class="float-left">
                                    <div class="media mt-2">
                                        <img src="@/assets/images/quera.jpg" class="place-logos" alt="quera">
                                        <div class="media-body ml-2">
                                                    <span class="d-block"> {{
                                                            $t("techolympics_rank")
                                                        }} - <small> 78 {{ $t("team") }} </small> </span>
                                            <span class="d-block"> Quera Tech Olympics - PHP/Laravel </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="float-right mt-2">
                                    <small> {{ $t("techolympics_time") }} </small>
                                    <vs-button class="m-0 mt-1 ml-auto custom-icon-size"
                                               href="https://quera.org/contest/assignments/71158/scoreboard"
                                               size="mini" transparent active blank color="#22333B">
                                        <i class='bx bx-chalkboard mr-1'></i>
                                        <span class="small-padding-top"> {{$t("scoreboard") }} </span>
                                    </vs-button>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                            <div class="w-100">
                                <div class="float-left">

                                </div>
                                <div class="float-right">

                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                    </div>
                    <div class="card w-100 border-0 mt-4">
                        <div class="card-title mb-0">
                            <div class="float-left">
                                <div class="media mt-2">
                                    <img src="@/assets/images/ieee.png" class="place-logos rounded mt-3" alt="fum">
                                    <div class="media-body ml-2">
                                        <span class="d-block" v-html="$t('explainable_holodetect')"></span>
                                        <span class="d-block extra-small"
                                              v-html="$t('explainable_holodetect_sub')"></span>
                                        <span class="d-block"> <small> <a
                                                href="https://ieeexplore.ieee.org/document/10326276"
                                                target="_blank"> {{
                                                $t("explainable_holodetect_site")
                                            }} </a> </small> </span>
                                    </div>
                                </div>
                            </div>
                            <div class="float-right mt-2">
                                <small> {{ $t("explainable_holodetect_time") }} </small>
                                <vs-button class="m-0 mt-1 ml-auto custom-icon-size"
                                           href="/images/explainable_holodetect.jpg"
                                           size="mini" transparent active blank color="#22333B">
                                    <i class='bx bx-certification mr-1'></i>
                                    <span class="small-padding-top"> {{ $t("certificate") }} </span>
                                </vs-button>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div class="w-100">
                            <div class="float-left">

                            </div>
                            <div class="float-right">

                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div class="card w-100 border-0 mt-4">
                        <div class="card-title mb-0">
                            <div class="float-left">
                                <div class="media mt-2">
                                    <img src="@/assets/images/fum.png" class="uni-logos" alt="fum">
                                    <div class="media-body ml-2">
                                        <span class="d-block"> {{ $t("iccke") }} </span>
                                        <span class="d-block small"> {{ $t("iccke_sub") }} </span>
                                        <span class="d-block"> <small> <a
                                                href="https://iccke.um.ac.ir/2022/en/Home/Content/3032"
                                                target="_blank"> {{
                                                $t("iccke_site")
                                            }} </a> </small> </span>
                                    </div>
                                </div>
                            </div>
                            <div class="float-right mt-2">
                                <small> {{ $t("iccke_time") }} </small>
                                <vs-button class="m-0 mt-1 ml-auto custom-icon-size"
                                           href="/images/iccke.jpg"
                                           size="mini" transparent active blank color="#22333B">
                                    <i class='bx bx-certification mr-1'></i>
                                    <span class="small-padding-top"> {{ $t("certificate") }} </span>
                                </vs-button>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div class="w-100">
                            <div class="float-left">

                            </div>
                            <div class="float-right">

                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div class="text-center">
                        <vs-button class="d-inline mt-3" transparent active color="#22333B" data-toggle="collapse"
                                   data-target="#collapseAchievement" aria-expanded="false"
                                   aria-controls="collapseAchievement">
                            {{ $t("more") }}
                        </vs-button>
                    </div>
                    <div class="collapse" id="collapseAchievement">
                        <div class="card w-100 border-0 mt-4">
                            <div class="card-title mb-0">
                                <div class="float-left">
                                    <div class="media mt-2">
                                        <img src="@/assets/images/aichallenge.jpg" class="place-logos rounded"
                                             alt="sharif">
                                        <div class="media-body ml-2">
                                            <span class="d-block"> {{ $t("aichallenge_rank") }} </span>
                                            <span
                                                    class="d-block"> AI Challenge - Sharif University Of Technology </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="float-right mt-2">
                                    <small> {{ $t("aichallenge_time") }} </small>
                                    <vs-button class="m-0 mt-1 ml-auto custom-icon-size"
                                               href="/images/aichallengecertificate.jpg"
                                               size="mini" transparent active blank color="#22333B">
                                        <i class='bx bx-certification mr-1'></i>
                                        <span class="small-padding-top"> {{ $t("certificate") }} </span>
                                    </vs-button>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                            <div class="w-100">
                                <div class="float-left">

                                </div>
                                <div class="float-right">

                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                        <div class="card w-100 border-0 mt-4">
                            <div class="card-title mb-0">
                                <div class="float-left">
                                    <div class="media mt-2">
                                        <img src="@/assets/images/acm.png"
                                             class="place-logos img-thumbnail border-0"
                                             alt="acm">
                                        <div class="media-body ml-2">
                                            <span class="d-block"> {{ $t("acm_judge") }} </span>
                                            <span class="d-block"> {{ $t("iaum") }} </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="float-right mt-2">
                                    <small> {{ $t("judge_time") }} </small>
                                    <vs-button class="m-0 mt-1 ml-auto custom-icon-size"
                                               href="/images/judgecertificate.jpg"
                                               size="mini" transparent active blank color="#22333B">
                                        <i class='bx bx-certification mr-1'></i>
                                        <span class="small-padding-top"> {{ $t("certificate") }} </span>
                                    </vs-button>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                            <div class="w-100">
                                <div class="float-left">

                                </div>
                                <div class="float-right">

                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                        <div class="card w-100 border-0 mt-4">
                            <div class="card-title mb-0">
                                <div class="float-left">
                                    <div class="media mt-2">
                                        <img src="@/assets/images/quera.jpg" class="place-logos" alt="quera">
                                        <div class="media-body ml-2">
                                                <span class="d-block"> {{
                                                        $t("codecup4_judge")
                                                    }} - <small> 50 {{ $t("participant") }} </small> </span>
                                            <span class="d-block"> Quera CodeCup 4 - PHP/Laravel </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="float-right mt-2">
                                    <small> {{ $t("codecup4_time") }} </small>
                                    <vs-button class="m-0 mt-1 ml-auto custom-icon-size"
                                               href="https://quera.ir/contest/assignments/5650/scoreboard"
                                               size="mini" transparent active blank color="#22333B">
                                        <i class='bx bx-chalkboard mr-1'></i>
                                        <span class="small-padding-top"> {{ $t("scoreboard") }} </span>
                                    </vs-button>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                            <div class="w-100">
                                <div class="float-left">

                                </div>
                                <div class="float-right">

                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                        <div class="card w-100 border-0 mt-4">
                            <div class="card-body p-0">
                                <div class="card-title mb-0">
                                    <div class="float-left">
                                        <div class="media mt-2">
                                            <img src="@/assets/images/quera.jpg" class="place-logos" alt="quera">
                                            <div class="media-body ml-2">
                                                    <span class="d-block"> {{
                                                            $t("connect6_rank")
                                                        }} - <small> 72 {{ $t("participant") }} </small> </span>
                                                <span class="d-block"> Quera Connect 6 - PHP/Laravel </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="float-right mt-2">
                                        <small> {{ $t("connect6_time") }} </small>
                                        <vs-button class="m-0 mt-1 ml-auto custom-icon-size"
                                                   href="https://quera.ir/course/assignments/4996/scoreboard"
                                                   size="mini" transparent active blank color="#22333B">
                                            <i class='bx bx-chalkboard mr-1'></i>
                                            <span class="small-padding-top"> {{ $t("scoreboard") }} </span>
                                        </vs-button>
                                    </div>
                                    <div class="clearfix"></div>
                                </div>
                                <div class="w-100">
                                    <div class="float-left">

                                    </div>
                                    <div class="float-right">

                                    </div>
                                    <div class="clearfix"></div>
                                </div>
                            </div>
                        </div>
                        <div class="card w-100 border-0 mt-4">
                            <div class="card-title mb-0">
                                <div class="float-left">
                                    <div class="media mt-2">
                                        <img src="@/assets/images/acm.png"
                                             class="place-logos img-thumbnail border-0"
                                             alt="acm">
                                        <div class="media-body ml-2">
                                                <span class="d-block"> {{
                                                        $t("acm_rank")
                                                    }} - <small> 60 {{ $t("participant") }} </small> </span>
                                            <span class="d-block"> ACM-ICPC Asia Region </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="float-right mt-2">
                                    <small> {{ $t("acm_time") }} </small>
                                    <vs-button class="m-0 mt-1 ml-auto custom-icon-size"
                                               href="/images/sharif.png"
                                               size="mini" transparent active blank color="#22333B">
                                        <i class='bx bx-certification mr-1'></i>
                                        <span class="small-padding-top"> {{ $t("certificate") }} </span>
                                    </vs-button>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                            <div class="w-100">
                                <div class="float-left">

                                </div>
                                <div class="float-right">

                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                        <div class="card w-100 border-0 mt-4">
                            <div class="card-title mb-0">
                                <div class="float-left">
                                    <div class="media mt-2">
                                        <img src="@/assets/images/sharif.png" class="place-logos" alt="sharif">
                                        <div class="media-body ml-2">
                                            <span class="d-block"> {{ $t("fanavard_rank") }} </span>
                                            <span
                                                    class="d-block"> Fanavard - Sharif University Of Technology </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="float-right mt-2">
                                    <small> {{ $t("fanavard_time") }} </small>
                                    <vs-button class="m-0 mt-1 ml-auto custom-icon-size"
                                               href="/images/ui.jpg"
                                               size="mini" transparent active blank color="#22333B">
                                        <i class='bx bx-certification mr-1'></i>
                                        <span class="small-padding-top"> {{ $t("certificate") }} </span>
                                    </vs-button>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                            <div class="w-100">
                                <div class="float-left">

                                </div>
                                <div class="float-right">

                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Achievement"
}
</script>

<style>

</style>

<style scoped>

</style>
